import React from "react";

interface NetProfitIconProps {
  color?: string;
}

const NetProfitIcon: React.FC<NetProfitIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width={21}
        height={20}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.776 11.667l.686.632c.15.146.224.22.198.282-.026.062-.132.062-.343.062H14.73c-1.324 0-2.398 1.056-2.398 2.357 0 .294.055.575.154.834m2.068 2.5l-.686-.632c-.15-.147-.224-.22-.197-.282.026-.063.131-.063.343-.063H16.6c1.324 0 2.398-1.055 2.398-2.357 0-.293-.055-.574-.154-.833"
          stroke="#044E97"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.991 9.584C19 9.083 19 8.947 19 8.334c0-3.143 0-4.714-.977-5.69-.976-.977-2.547-.977-5.69-.977H8.999c-3.143 0-4.714 0-5.69.976-.977.977-.977 2.548-.977 5.69 0 3.143 0 4.715.976 5.691.977.976 2.548.976 5.69.976h.834"
          stroke="#044E97"
          strokeWidth={1.2}
          strokeLinecap="round"
        />
        <path
          d="M16.082 8.334h-.008M5.248 8.334h-.007"
          stroke="#044E97"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.749 8.333a2.083 2.083 0 11-4.167 0 2.083 2.083 0 014.167 0z"
          stroke="#044E97"
          strokeWidth={1.5}
        />
      </svg>
    </>
  );
};
export { NetProfitIcon };
